<template>
  <div>
    <b-modal
        hide-footer
        id="modal-edit-call-info"
        centered
        size="lg"
        title="Notiz"
        no-close-on-backdrop
    >
          <b-row>
            <b-col
                md="12"
                xl="12"
            >
              <b-form-group
                  label=""
              >
                <quill-editor
                    v-model="edit.text"
                    :options="editorOption"
                >
                  <div
                      id="toolbar"
                      slot="toolbar"
                      class="text-white"
                  >
                    <!-- Add a bold button -->
                    <button class="ql-bold">
                      Boldsadasd
                    </button>
                    <button class="ql-italic">
                      Italic
                    </button>

                    <!-- Add font size dropdown -->
                    <select class="ql-size">
                      <option value="small" />
                      <!-- Note a missing, thus falsy value, is used to reset to default -->
                      <option selected />
                      <option value="large" />
                      <option value="huge" />
                    </select>

                    <select class="ql-font">
                      <option selected="selected" />
                      <option value="serif" />
                      <option value="monospace" />
                    </select>

                    <!-- Add subscript and superscript buttons -->
                    <button
                        class="ql-script"
                        value="sub"
                    />
                    <button
                        class="ql-script"
                        value="super"
                    />

                  </div>
                </quill-editor>

                <b-card-code title="Dateien" v-if="noteData != null">
                  <b-row>
                    <b-col
                        cols="12"
                    >
                      <b-button @click="$root.$emit('OpenFileMenu', 4, groupId)">Neue Datei</b-button>
                      <FileBoxedView class="mt-2" ref="noteFileView"></FileBoxedView>
                    </b-col>
                  </b-row>
                </b-card-code>

              </b-form-group>
            </b-col>
            <b-col
                md="12"
                xl="12"
                v-if="noteData != null"
            >
              <b-card-code
                  v-for="l in noteData">
                <div>
                  <b-row class="float-right">{{l.User}} -  {{formatDate(l.Created)}} (<timeago :datetime="l.Created" locale="de" :auto-update="60"></timeago>)</b-row>
                  <div v-html="l.Text"></div>
                  <b-row style="background-color: #e70e36; height: 0.01vh;" class="mt-1"></b-row>
                </div>
              </b-card-code>
            </b-col>
          </b-row>
          <b-row>
          </b-row>
      <div>
        <b-button class="float-right" variant="success" @click="SaveNote">
          OK
        </b-button>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <div></div>
      </template>
    </b-modal>
  </div>
</template>

<script>
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import {
  BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BBadge, BDropdown, BButton, BFormInput, BPagination, BFormSelect, BCol, BFormGroup, BInputGroupAppend, BInputGroup, BRow, BTable, BAlert, BFormCheckbox
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { quillEditor } from 'vue-quill-editor'
import BCardCode from '@core/components/b-card-code'
import FileBoxedView from '@/layouts/components/FileBoxedView.vue'

export default {
  components: {
    FileBoxedView,
    BCardCode,
    quillEditor,
    BButton,
    BRow,
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      groupId: '',
      ConnectTargets: [],
      noteData: null,
      edit: {
        text: '',
      },
      editorOption: {
        theme: 'snow',
        modules: {
          toolbar: '#toolbar',
        },
      },
    }
  },
  mounted() {
  },
  methods: {
    Reset() {
      this.edit.text = ''
      this.noteData = null;

    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          },
      )}`
    },
    SaveNote() {
      this.$http.post('/note/add', JSON.stringify({
        noteId: this.groupId,
        text: this.edit.text,
      }))
          .then(rr => {
            if (rr.data.success) {
              this.OpenNote();
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    async OpenNote() {
      this.Reset();
      await this.$http.get('/note/get/' + this.groupId)
          .then(rr => {
            if (rr.data.success) {
              this.noteData = rr.data.textList;
              this.ConnectTargets = rr.data.ConnectTargets;
            }
          })
          .catch(err => {
            console.error(err)
          })
      this.ConnectTargets.forEach(i => {
        if(i.TargetType == 7) {
          console.log(i)
          this.$refs.noteFileView.getFile(i.TargetId)
        }
      })
    },
    OpenEditMenu(groupId) {
      this.groupId = groupId
      this.$bvModal.show('modal-edit-call-info')
      if(this.groupId != "") {
        this.OpenNote();
      }
    },
    CloseCallEditMenu() {
      this.$bvModal.hide('modal-edit-call-info')
    },
  },
}
</script>

<style scoped>

</style>